import LargeBlueButton from '@components/common/button/LargeBlueButton';
import PageHeader from '@components/common/PageHeader';
import { GenericAuthContext } from '@src/authContexts';
import React, { ReactNode, useContext } from 'react';
import { useHistory } from 'react-router-dom';

interface AccountBaseProps {
  children: ReactNode;
}

const AccountBase: React.FC<AccountBaseProps> = ({ children }) => {
  const history = useHistory();
  const { user, userDoc } = useContext(GenericAuthContext);

  const userData = userDoc.data();

  return (
    <div className='w-full h-full overflow-auto'>
      <PageHeader text='ACCOUNT'></PageHeader>
      <div className='mx-10 mt-10 text-xl'>
        <h1 className='font-raleway text-coffee text-4xl font-semibold'>PUBLIC DATA</h1>
        {children}
      </div>
      <div className='mx-10 my-10 text-xl'>
        <h1 className='font-raleway text-coffee text-4xl font-semibold'>PRIVATE DATA</h1>
        <p className='my-4'>
          <strong>Name: </strong> {userData?.static.firstName} {userData?.static.lastName}
        </p>
        <p className='my-4'>
          <strong>Email: </strong> {user.email}
        </p>
        <LargeBlueButton
          text='CHANGE PASSWORD'
          onClick={() => history.push('/changepassword')}
        ></LargeBlueButton>
      </div>
    </div>
  );
};

export default AccountBase;
